import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, ChevronRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden" data-id="element-221">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/cqAvUtvcQTgh5rHCaYNAM9/fdhjkl_(2).jpg")'
    }} data-id="element-222">
        <div className="absolute inset-0 bg-gradient-to-r from-uganda-black/80 via-uganda-black/60 to-transparent" data-id="element-223"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 flex flex-col md:flex-row items-center justify-between" data-id="element-224">
        {/* Text Content */}
        <div className="w-full md:w-2/3 text-white" data-id="element-225">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-226">
            <span className="inline-block py-1 px-3 rounded-full bg-uganda-yellow/20 text-uganda-yellow font-semibold text-sm mb-4 border border-uganda-yellow/30" data-id="element-227">
              Official Portal of MAAIF
            </span>
            <h1 className="text-4xl md:text-6xl font-bold leading-tight mb-6" data-id="element-228">
              Transforming Subsistence Farming into{' '}
              <span className="text-uganda-yellow" data-id="element-229">Commercial Agriculture</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-200 mb-6 max-w-2xl leading-relaxed" data-id="element-230">
              Working towards a Competitive, Profitable and Sustainable
              Agricultural Sector for the Republic of Uganda.
            </p>

            <div className="bg-black/30 border-l-4 border-uganda-yellow p-4 mb-8 max-w-2xl rounded-r-md backdrop-blur-sm" data-id="element-231">
              <p className="italic text-gray-200 text-sm md:text-base" data-id="element-232">
                "In this term, we will spend more time with the farmers in the
                fields than in conferences."
              </p>
              <p className="text-xs text-uganda-yellow mt-2 font-semibold" data-id="element-233">
                — Hon. Frank Tumwebaze, Minister of Agriculture
              </p>
            </div>

            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-234">
              <Link to="/applications" className="bg-uganda-green hover:bg-green-700 text-white px-8 py-3.5 rounded-md font-semibold flex items-center justify-center transition-colors shadow-lg" data-id="element-235">
                Access Services
                <ArrowRight className="ml-2 w-5 h-5" data-id="element-236" />
              </Link>
              <Link to="/projects" className="bg-transparent border-2 border-white hover:bg-white/10 text-white px-8 py-3.5 rounded-md font-semibold flex items-center justify-center transition-colors" data-id="element-237">
                Explore Programs
              </Link>
            </div>
          </motion.div>
        </div>

        {/* Quick Stats / Info Card */}
        <motion.div className="hidden md:flex flex-col space-y-4 w-full md:w-1/3 pl-8 mt-12 md:mt-0" initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-238">
          <div className="bg-white/10 backdrop-blur-md border border-white/20 p-6 rounded-lg text-white" data-id="element-239">
            <h3 className="text-sm uppercase tracking-wider text-uganda-yellow font-bold mb-2" data-id="element-240">
              Sector Impact
            </h3>
            <div className="mb-4" data-id="element-241">
              <div className="text-4xl font-bold mb-1" data-id="element-242">72%</div>
              <div className="text-sm text-gray-300" data-id="element-243">
                of workforce employed in agriculture
              </div>
            </div>
            <div className="w-full h-px bg-white/20 my-4" data-id="element-244"></div>
            <div data-id="element-245">
              <div className="text-4xl font-bold mb-1" data-id="element-246">24%</div>
              <div className="text-sm text-gray-300" data-id="element-247">
                contribution to National GDP
              </div>
            </div>
            <Link to="/sector-statistics" className="mt-6 text-sm font-semibold flex items-center hover:text-uganda-yellow transition-colors" data-id="element-248">
              View full statistics <ChevronRight className="w-4 h-4 ml-1" data-id="element-249" />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>;
}